export default __webpack_public_path__ + "static/media/NinthAve.d58adc39.jpg";